import { render, staticRenderFns } from "./subcontractor-certification-settings-modal.vue?vue&type=template&id=f95f7ef4"
import script from "./subcontractor-certification-settings-modal.vue?vue&type=script&lang=js"
export * from "./subcontractor-certification-settings-modal.vue?vue&type=script&lang=js"
import style0 from "./subcontractor-certification-settings-modal.vue?vue&type=style&index=0&id=f95f7ef4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports